import gql from 'graphql-tag'

export default gql`
  fragment PostLearningContentAssets on Post {
    learningContentAssets {
      id
      title
      type
      documentLength
    }
  }
`
